/**
 * withCart
 * HOC for wrapping the provided component with CartProvider
 */

import React from 'react'

import DineInCartProvider from './dine-in-cart-provider'

export default function withCart (WrappedComponent) {
  return function DineInCartProviderHOC(props) {
    return (
      <DineInCartProvider>
        <WrappedComponent {...props} />
      </DineInCartProvider>
    )
  }
}
